export default "__VITE_ASSET__CHhcWI5Q__"